import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tab__container" }

import { useRoute } from 'vue-router';
import { i18n } from '@/i18n';
import { ITabRoute } from '@/coreDomainsModule/tabRoutes';


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterBusinessPageTab',
  setup(__props) {

const t = i18n.t;
const route = useRoute();

const tabRoutes: Array<ITabRoute> = [
  {
    name: 'データ入力',
    path: '/input-data',
  },
  {
    name: '取引削除',
    path: '/business-removal',
  },
  {
    name: '個別編集',
    path: '/business-edit-individual',
  },
];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabRoutes, (tab) => {
      return _createElementVNode("div", {
        key: tab.path
      }, [
        _createVNode(_component_router_link, {
          to: tab.path
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(_unref(route).path === tab.path ? 'tab__active' : 'tab__inactive')
            }, _toDisplayString(_unref(t)(tab.name)), 3)
          ], undefined, true),
          _: 2
        }, 1032, ["to"])
      ])
    }), 64))
  ]))
}
}

})